import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FeaturesGrid from './components/FeaturesGrid';
import PricingSection from './components/PricingSection';
import TrustSignals from './components/TrustSignals';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const HomepageSalesLanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>AuthorPreneur AI - Build Authority Through AI-Powered Book Creation</title>
        <meta
          name="description"
          content="Transform your expertise into published books with AI assistance. Join 2,500+ entrepreneurs building authority and credibility through professional book publishing."
        />
        <meta name="keywords" content="AI book writing, author platform, book publishing, entrepreneur authority, business credibility, Amazon KDP, book creation software" />
        <meta property="og:title" content="AuthorPreneur AI - Build Authority Through AI-Powered Book Creation" />
        <meta property="og:description" content="Create professional books in weeks with AI-powered writing, formatting, and publishing guidance." />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />

        <main>
          <HeroSection />
          <FeaturesGrid />
          <PricingSection />
          <TrustSignals />
          <FAQSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default HomepageSalesLanding;